import { Loader2, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

export function RefreshButton({
  onRefresh,
  refreshing,
  className,
}: {
  onRefresh: () => void;
  refreshing: boolean;
  className?: string | undefined;
}) {
  return (
    <Button
      variant="outline"
      className={className}
      onClick={onRefresh}
      disabled={refreshing}
      aria-label="Refresh pending doctors"
    >
      {refreshing ? <Loader2 className="size-4 animate-spin" /> : <RefreshCw className="size-4" />}
      {refreshing ? "Refreshing…" : "Refresh"}
    </Button>
  );
}
